import React from 'react'
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import Carousel from "react-material-ui-carousel";
import ContentCards from "../components/homepage/contentCards";
import CustomContainer from "../components/layout/container";
import LandingPageCards from "../components/homepage/landingPageCards";
import { LandingPageInfo } from "../utils/homepageData"
import slider1 from "../images/Peaks_blue_1600_100.jpg";
import slider2 from "../images/Globe_blue1_1600_100.jpg";
import slider3 from "../images/orange2_stockprices_1600_100.jpg";
import slider4 from "../images/riskNZmacroMapDark1_1600_100.jpg";
import slider5 from "../images/Peaks_Teal_1600_100.jpg";
import slider6 from "../images/MobilePhone_PaleOrange_1600_100.jpg";

export default function Home() {

  //  const carouselHeight = "150px";
  const carouselHeight = "100px";
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <CustomContainer>
      <Grid>
        <title>Manchester Economic Forecasting</title>
        <meta
          name="description"
          content=" Identify & Quantify Macroeconomic/Esg risk"
        />
      </Grid>
      <Box pt={1}>
        <Typography
          color="primary"
          variant="h3"
          align="left"
          fontWeight={700}
          mb={1.5}
        >
          Manchester Economic Forecasting{" "}
        </Typography>
        <Box sx={{
          mb: 1,
          mt: 0,
          '& .MuiPaper-root': { // Target any Paper components
            marginBottom: 0,
            marginTop: 0
          },
          '& .MuiBox-root': { // Target Box components
            marginBottom: 0,
            marginTop: 0
          },
          height: carouselHeight // Explicitly set height
        }}>
          <Carousel
            height={carouselHeight}
            stopAutoPlayOnHover
            autoPlay={true}
            interval={4000}
            sx={{
              '& .MuiBox-root': {
                marginBottom: 0
              }
            }}
          >
            <Box sx={{ position: "relative", width: "100%", height: carouselHeight }}>
              <img
                src={slider1}
                alt="slider1"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover", // Use "cover" to ensure the image fills the container
                  objectPosition: "center center",
                }}
                title={`Risk is everywhere - Demand, Cost, Trade/Geopolitical, Carbon/Fiscal, Esg, Technological...`}
              />
              <Box
                sx={{
                  position: "absolute",
                  top: "50%", // Center vertically
                  left: "50%", // Center horizontally
                  transform: "translate(-50%, -50%)", // Adjust for exact centering
                  width: "100%", // Ensure the text container spans the full width
                  textAlign: "center", // Center the text
                  color: "#fff", // Set text color
                }}
              >
                <Typography
                  sx={{
                    color: "#fff",
                    textShadow: "0 1px 2px rgb(0 0 0 / 60%)",
                  }}
                  variant={smScreen ? "h4" : "h2"}
                  fontWeight={"bold"}
                >
                  Moving beyond fallible forecasts to smart scenario analysis
                </Typography>
              </Box>
            </Box>
            <Box sx={{ position: "relative", width: "100%", height: carouselHeight }}>
              <img
                src={slider2}
                alt="slider2"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center center",
                }}
                title="Risk is everywhere - Demand, Cost, Trade/Geopolitical, Carbon/Fiscal, Esg, Technological..."
              />
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "100%",
                  textAlign: "center",
                  color: "#fff",
                }}
              >
                <Typography
                  sx={{
                    color: "#fff",
                    textShadow: "0 1px 2px rgb(0 0 0 / 60%)",
                  }}
                  variant={smScreen ? "h4" : "h2"}
                  fontWeight={"bold"}
                >
                  Bespoke client models - driven by MEF&apos;s Global models
                </Typography>
              </Box>
            </Box>

            {/* Slide 2 */}
            <Box sx={{ position: "relative", width: "100%", height: carouselHeight }}>
              <img
                src={slider3}
                alt="slider3"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "top center",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "100%",
                  textAlign: "center",
                  color: "#fff",
                }}
              >
                <Typography
                  sx={{
                    color: "#fff",
                    textShadow: "0 1px 2px rgb(0 0 0 / 60%)",
                  }}
                  variant={smScreen ? "h4" : "h2"}
                  fontWeight={"bold"}
                >
                  Pre-run scenarios - driving your sensitivity/risk analysis, cost-effectively
                </Typography>
              </Box>
            </Box>

            {/* Slide 3 */}
            <Box sx={{ position: "relative", width: "100%", height: carouselHeight }}>
              <img
                src={slider4}
                alt="slider4"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "top center",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "100%",
                  textAlign: "center",
                  color: "#fff",
                }}
              >
                <Typography
                  sx={{
                    color: "#fff",
                    textShadow: "0 1px 2px rgb(0 0 0 / 60%)",
                  }}
                  variant={smScreen ? "h4" : "h2"}
                  fontWeight={"bold"}
                >
                  risk2NZ App - Explore Economic/Energy Risks to Net Zero Emissions
                </Typography>
              </Box>
            </Box>

            {/* Slide 4 */}
            <Box sx={{ position: "relative", width: "100%", height: carouselHeight }}>
              <img
                src={slider5}
                alt="slider5"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "top center",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "100%",
                  textAlign: "center",
                  color: "#fff",
                }}
              >
                <Typography
                  sx={{
                    color: "#fff",
                    textShadow: "0 1px 2px rgb(0 0 0 / 60%)",
                  }}
                  variant={smScreen ? "h4" : "h2"}
                  fontWeight={"bold"}
                >
                  Energy/Emissions - exploring Carbon transition pathways/risks to 2050
                </Typography>
              </Box>
            </Box>

            {/* Slide 5 */}
            <Box sx={{ position: "relative", width: "100%", height: carouselHeight }}>
              <img
                src={slider6}
                alt="slider6"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "top center",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "100%",
                  textAlign: "center",
                  color: "#fff",
                }}
              >
                <Typography
                  sx={{
                    color: "#fff",
                    textShadow: "0 1px 2px rgb(0 0 0 / 60%)",
                  }}
                  variant={smScreen ? "h4" : "h2"}
                  fontWeight={"bold"}
                >
                  Applied Education - bringing real-world Economic risk tools/data to class
                </Typography>
              </Box>
            </Box>
          </Carousel>
        </Box>

        <Box pb={2}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12}>
              <ContentCards
                title="Beyond forecasts: Smart Scenarios to mitigate growing Global risk"
                objectFit="fill"
                subTitle="MEF provide, cost-effective, real-world, “what-if” scenario analysis to SMEs/Exporters, Consultancies, Energy/Emissions Analysts, Investors & Educators."
                body={``}
                isHomePage={true}
              />
            </Grid>

            {LandingPageInfo.map((info, index) => (
              <Grid item xs={12} sm={12} md={3} key={index}>
                <LandingPageCards info={info} />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </CustomContainer>
  )
}
